import React from "react"
import PropTypes from "prop-types"
import EmailAllButton from "./EmailAllButton"
import LoadingButton from "app/static/frontend/components/LoadingButton"
import SheetsButton from "app/static/frontend/sheets/components/SheetsButton"
import Icon from "../../components/Icon"
import { helpTexts } from "app/static/frontend/sheets/components/helpTexts"
import { createSheetKey } from "app/static/frontend/sheets/selectors/sheet-selectors"
import urls from "app/static/frontend/imports/desktopPaths"

const TopToolBarCustomActions = ({
    shouldDisplayMathBar,
    isLoadingMathBar,
    toggleShowMath,
    params,
    canAddColumns,
    sheetId,
    columns,
    sheetInitiallyLoading,
    isDownloading,
    download,
    shouldShowEmailAllButton,
    createEmailFromSheet,
    emailAllParams,
    table,
}) => {
    const renderDisplaySheetsButton = () => {
        if (shouldDisplayMathBar) {
            return (
                <SheetsButton
                    buttonText={helpTexts.hideStats.buttonText}
                    disabledText={helpTexts.hideStats.buttonText}
                    icon={<Icon name="fa-minus-circle" />}
                    tooltipLabel={helpTexts.hideStats.tooltip}
                    onClick={() => !isLoadingMathBar && toggleShowMath(createSheetKey(params.sheetId), false)}
                    style={{ border: "none", fontSize: "14px" }}
                />
            )
        } else {
            return (
                <SheetsButton
                    buttonText={helpTexts.showStats.buttonText}
                    disabledText={helpTexts.showStats.buttonText}
                    icon={<Icon name="fa-calculator" />}
                    tooltipLabel={helpTexts.showStats.tooltip}
                    onClick={() => !isLoadingMathBar && toggleShowMath(createSheetKey(params.sheetId), true)}
                    style={{ border: "none" }}
                />
            )
        }
    }
    const sheetIsLockedForUser = !canAddColumns

    return (
        <div className="sheet-button-container" style={{ display: "flex", gap: "10px" }}>
            {/* Disable Adding New Columns if sheet is locked and user is not creator */}
            <SheetsButton
                disabled={sheetIsLockedForUser}
                disabledText={helpTexts.add_column.disabledText}
                disabledTooltipLabel={helpTexts.add_column.disabledTooltip}
                segueUrl={`${urls.sheet}${sheetId}/add_column/${columns.size}/`}
                tooltipLabel={helpTexts.add_column.tooltip}
                variant={"primary"}
                style={{ fontSize: "14px" }}
            />

            {/* Settings Button, disabled if sheet is locked */}
            <SheetsButton
                buttonText={helpTexts.settings.buttonText}
                icon={<Icon name="cog" />}
                disabled={sheetIsLockedForUser}
                disabledText={helpTexts.settings.disabledText}
                disabledTooltipLabel={helpTexts.settings.disabledTooltip}
                segueUrl={`${urls.sheet}${sheetId}/edit/`}
                tooltipLabel={helpTexts.settings.tooltip}
                style={{ fontSize: "14px" }}
            />

            <LoadingButton
                bsSize="md"
                buttonText={"Download"}
                className="sheets-buttons"
                disabled={sheetInitiallyLoading} // need to wait for sheet to resolve first
                id="download-sheet"
                icon={<Icon name="download" />}
                isLoading={isDownloading}
                loadingText="Downloading"
                onClick={download}
                style={{ border: "none", fontSize: "14px" }}
                variant="default"
                onClickArg={table}
            />

            {/* Email All Button, showed only if on an official/staffer/contact sheet and not loading  */}
            {shouldShowEmailAllButton && (
                <EmailAllButton
                    onClick={() => createEmailFromSheet(emailAllParams)}
                    style={{ border: "none", fontSize: "14px" }}
                />
            )}

            {renderDisplaySheetsButton()}
        </div>
    )
}

TopToolBarCustomActions.propTypes = {
    shouldDisplayMathBar: PropTypes.bool,
    isLoadingMathBar: PropTypes.bool,
    toggleShowMath: PropTypes.func,
    params: PropTypes.object,
    canAddColumns: PropTypes.bool,
    sheetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    columns: PropTypes.object,
    sheetInitiallyLoading: PropTypes.bool,
    isDownloading: PropTypes.bool,
    download: PropTypes.func,
    shouldShowEmailAllButton: PropTypes.bool,
    createEmailFromSheet: PropTypes.func,
    emailAllParams: PropTypes.object,
    table: PropTypes.object,
}

export default TopToolBarCustomActions
